"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonNodeType = void 0;
var JsonNodeType;
(function (JsonNodeType) {
    JsonNodeType["ARRAY"] = "ARRAY";
    JsonNodeType["BINARY"] = "BINARY";
    JsonNodeType["BOOLEAN"] = "BOOLEAN";
    JsonNodeType["MISSING"] = "MISSING";
    JsonNodeType["NULL"] = "NULL";
    JsonNodeType["NUMBER"] = "NUMBER";
    JsonNodeType["OBJECT"] = "OBJECT";
    JsonNodeType["POJO"] = "POJO";
    JsonNodeType["STRING"] = "STRING";
})(JsonNodeType = exports.JsonNodeType || (exports.JsonNodeType = {}));
//# sourceMappingURL=jsonNodeType.js.map